<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-title>{{ 'general.search' | translate }}</ion-title>
    <ion-buttons slot="start">
      <ion-button
        (click)="cancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-grid class="ion-padding-vertical-0 ion-margin-top-0 block-content-round">
    <ion-row>
      <ion-col>
        <form [formGroup]="searchForm">
          <ion-list class="ion-no-margin ion-no-padding">
            <ion-item>
              <ion-toggle
                justify="start"
                labelPlacement="end"
                formControlName="withoutDigitizedDeliveryNotes"
              >
                {{ 'freight.search.without_digitized_delivery_notes' | translate }}
              </ion-toggle>
            </ion-item>

            <ion-item>
              <ion-toggle
                justify="start"
                labelPlacement="end"
                formControlName="pendingPaperDeliveryNote"
              >
                {{ 'freight.search.paper_note_pending' | translate }}
              </ion-toggle>
            </ion-item>
          </ion-list>
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-grid class="ion-padding-vertical-0">
      <ion-row>
        <ion-col>
          <ion-button
            (click)="confirm()"
            color="primary"
            expand="block"
            fill="solid"
          >
            <ion-icon
              src="../assets/material-symbols/search_24dp.svg"
              slot="start"
            ></ion-icon>
            {{ 'general.search' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
